
import axioAdmin from "./intercepters";
import { API_URL } from "./url-constant";
import axioUser from "./user-intercepter";

//admin login
export async function adminLogin(payload) {
    return await axioAdmin?.post(`${API_URL?.adminAuth?.login}`, payload);
}

//admin forgetPassword
export async function adminForgetPassword(email) {
    return await axioAdmin?.post(`${API_URL?.adminAuth?.Forgetpassword}?email=${email}`);
}

//admin forgetPassword
export async function adminResetPassword(payload) {
    return await axioAdmin?.post(`${API_URL?.adminAuth?.resetpassword}`, payload);
}

export async function updateAdminProfile(payload) {
    return await axioAdmin?.post(`${API_URL?.adminAuth?.UpdateAdmin}`, payload);
}
//admin Role
export async function getallAdminRole(payload) {
    return await axioAdmin?.post(`${API_URL?.AdminRole?.getRole}`, payload);
}

//ADD ROLE
export async function adminAddRole(payload) {
    return await axioAdmin?.post(`${API_URL?.AdminRole?.addRole}`, payload);
}

//GET MODULES
export async function getAllModule() {
    return await axioAdmin?.get(`${API_URL?.AdminRole?.getModule}`);
}

export async function getallAdminModel(pageIndex, pageSize, searchText, sortDirection, sortColumn) {
    return await axioAdmin?.get(
        `${API_URL?.ModelManagement?.modelList}?pageIndex=${pageIndex}&pageSize=${pageSize}` +
        (searchText ? `&searchText=${searchText}` : '') + (sortDirection ? `&direction=${sortDirection}` : '') + (sortColumn ? `&filterByFieldName=${sortColumn}` : '')
    );
}

export async function getallAdminDimension(pageIndex, pageSize, searchText, sortDirection, sortColumn, status, modelId) {
    return await axioAdmin?.get(
        `${API_URL?.DimensionManagement?.dimensionList}?pageIndex=${pageIndex}&pageSize=${pageSize}` +
        (searchText ? `&searchText=${searchText}` : '') + (sortDirection ? `&direction=${sortDirection}` : '') + (sortColumn ? `&filterByFieldName=${sortColumn}` : '') + (status ? `&status=${status}` : '') + (modelId ? `&modelId=${modelId}` : '')
    );
}

export async function getallAdminSubDimension(pageIndex, pageSize, searchText, sortDirection, sortColumn, modelId, dimensionId) {
    return await axioAdmin?.get(
        `${API_URL?.SubDimensionManagement?.subdimensionList}?pageIndex=${pageIndex}&pageSize=${pageSize}` +
        (searchText ? `&searchText=${searchText}` : '') + (sortDirection ? `&direction=${sortDirection}` : '') + (sortColumn ? `&filterByFieldName=${sortColumn}` : '') + (modelId ? `&modelId=${modelId}` : '') + (dimensionId ? `&dimensionId=${dimensionId}` : '')
    );
};

export async function getallAdminCriteria(pageIndex, pageSize, searchText, sortDirection, sortColumn, modelId, dimensionId, subDimensionId) {
    return await axioAdmin?.get(
        `${API_URL?.CriteriaManagement?.CriteriaList}?pageIndex=${pageIndex}&pageSize=${pageSize}` +
        (searchText ? `&searchText=${searchText}` : '') + (sortDirection ? `&direction=${sortDirection}` : '') + (sortColumn ? `&filterByFieldName=${sortColumn}` : '') + (modelId ? `&modelId=${modelId}` : '') + (dimensionId ? `&dimensionId=${dimensionId}` : '') + (subDimensionId ? `&subDimensionId=${subDimensionId}` : '')
    );
};

export async function addAdminModel(payload) {
    return await axioAdmin?.post(`${API_URL?.ModelManagement?.addModel}`, payload);
}

export async function addAdminDimension(payload) {
    return await axioAdmin?.post(`${API_URL?.DimensionManagement?.adddimension}`, payload);
}
export async function getAllModels(status) {
    return await axioAdmin?.get(`${API_URL?.DimensionManagement?.getAllModels}?status=${status}`);
}

export async function addAdminSubDimension(payload) {
    return await axioAdmin?.post(`${API_URL?.SubDimensionManagement?.addSubDimension}`, payload);
}

export async function blockRoleStatus(id, status) {
    return await axioAdmin?.get(`${API_URL?.AdminRole?.blockStaus}?id=${id}&status=${status}`)
}

export async function getAdminModelBlock(id, status) {
    return await axioAdmin?.post(
        `${API_URL?.ModelManagement?.blockModel}?id=${id}&status=${status}`)
}

export async function getAdminDimensionBlock(id, status) {
    return await axioAdmin?.post(
        `${API_URL?.DimensionManagement?.blockDimension}?id=${id}&status=${status}`)
}

export async function getAdminSubDimensionBlock(id, status) {
    return await axioAdmin?.post(
        `${API_URL?.SubDimensionManagement?.blocksubDimension}?id=${id}&status=${status}`)
}

export async function getAllDimensionByModelId(id, status) {
    return await axioAdmin?.get(
        `${API_URL?.SubDimensionManagement?.getAllDimensionByModelId}?id=${id}&status=${status}`
    );
}

export async function getAllSubDimensionById(id, status) {
    return await axioAdmin?.get(
        `${API_URL?.SubDimensionManagement?.subdimensionById}?id=${id}&status=${status}`
    );
}

export async function getRoleById(id) {
    return await axioAdmin?.get(
        `${API_URL?.AdminRole?.getRoleById}?roleId=${id}`
    );
}

export async function getallAdmin(payload) {
    return await axioAdmin?.post(`${API_URL?.AdminRole?.getAllAdmin}`, payload);
}

export async function getAdminBlock(id, status) {
    return await axioAdmin?.get(
        `${API_URL?.AdminRole?.blockAdmin}?id=${id}&status=${status}`)
}

export async function addAllAdmin(payload) {
    return await axioAdmin?.post(`${API_URL?.AdminRole?.addAdmin}`, payload);
}

// customer management 
export async function addEmployee(payload) {
    return await axioAdmin?.post(`${API_URL?.CustomerManagement?.addEmployee}`, payload);
}
export async function getEmployeeById(id) {
    return await axioAdmin?.get(
        `${API_URL?.CustomerManagement?.getEmployeeById}?id=${id}`)
}
export async function getAllEmployee(payload) {
    return await axioAdmin?.post(`${API_URL?.CustomerManagement?.getAllEmployee}`, payload);
}
export async function addCompany(payload) {
    return await axioAdmin?.post(`${API_URL?.CustomerManagement?.addCompany}`, payload);
}
export async function getAllCompany(payload) {
    return await axioAdmin?.post(`${API_URL?.CustomerManagement?.getAllCompany}`, payload);
}
export async function getCompanyById(id) {
    return await axioAdmin?.get(
        `${API_URL?.CustomerManagement?.getCompanyById}?id=${id}`)
}
export async function CompanyactiveInactive(id, status) {
    return await axioAdmin?.post(
        `${API_URL?.CustomerManagement?.activeInactiveCompany}?id=${id}&status=${status}`)
}
export async function activeInactiveEmployee(id, status) {
    return await axioAdmin?.post(
        `${API_URL?.CustomerManagement?.activeInactiveEmployee}?id=${id}&status=${status}`)
}
export async function getAllCountry() {
    return await axioAdmin?.get(`${API_URL?.country?.getAllCountry}`);
}
export async function getAllCompanies(status) {
    const url = status
        ? `${API_URL?.CustomerManagement?.getAllCompanies}?status=${status}`
        : `${API_URL?.CustomerManagement?.getAllCompanies}`;

    return await axioAdmin?.get(url);
}
export async function getAllCampaignByCompanyId(companyId) {

    const url = companyId
        ? `${API_URL?.CustomerManagement?.getAllCampaignByCompanyId}?companyId=${companyId}`
        : `${API_URL?.CustomerManagement?.getAllCampaignByCompanyId}`;

    return await axioAdmin?.get(url);
}

export async function getAllEmployeesByCampaignId(companyId, campaignId) {
    return await axioAdmin?.get(
        `${API_URL?.CustomerManagement?.getAllEmployeesByCampaignId}?companyId=${companyId}&campaignId=${campaignId}`
    );
}


export async function getindividualResult(campaignId, employeeId, selectedSubId,type) {

    return await axioAdmin?.get(`${API_URL.CustomerManagement.individualResult}?campaignId=${campaignId}&employeeId=${employeeId}&subDimensionId=${selectedSubId}&type=${type}`);

}

export async function getindividualResultUser(id) {
    return await axioUser?.get(`${API_URL?.CustomerManagement?.individualResult}?employeeId=${id}`);
}

export async function addindividualResultRemark(employeeId, remark) {
    return await axioAdmin?.post(
        `${API_URL?.CustomerManagement?.individualResultValidate}?employeeId=${employeeId}&remark=${remark}`)
}

export async function AddCriteriaAdmin(payload) {
    return await axioAdmin?.post(`${API_URL?.CriteriaManagement?.addCriteria}`, payload);
}

export async function getAllModelDimensionSubDimensionList(ModelId) {

    return await axioAdmin?.post(
        `${API_URL?.ModelManagement?.modellistwithallchild}?ModelId=${ModelId}`)
}

export async function CriteriactiveInactive(id, status) {
    return await axioAdmin?.post(
        `${API_URL?.CriteriaManagement?.blockCriteria}?id=${id}&status=${status}`)
}
////////////////USERAPIS//////////////////////
export async function userLogin(email) {
    return await axioUser?.post(
        `${API_URL?.userLogin?.login}?email=${email}`)
}
export async function userOtpVerify(email, otp) {
    return await axioUser?.post(
        `${API_URL?.userLogin?.verifyOtp}?email=${email}&otp=${otp}`)
}
//////// charts api /////////
export async function addRemark(payload) {
    return await axioAdmin?.post(
        `${API_URL?.ChartData?.addRemark}`, payload)
}
export async function OverallParticipation(companyId, campaignId, type, graphName) {
    return await axioAdmin?.get(
        `${API_URL?.ChartData?.OverallParticipationId}?companyId=${companyId}&campaignId=${campaignId}&type=${type}&graphName=${graphName}`)
}
export async function dimensionParticipation(companyId, campaignId, type, graphName) {
    return await axioAdmin?.get(
        `${API_URL?.ChartData?.dimensionParticipationId}?companyId=${companyId}&campaignId=${campaignId}&type=${type}&graphName=${graphName}`)
}
export async function radialDimensionDetails(companyId, campaignId, type, graphName) {
    return await axioAdmin?.get(
        `${API_URL?.ChartData?.radialDimensionDetailsId}?companyId=${companyId}&campaignId=${campaignId}&type=${type}&graphName=${graphName}`)
}
export async function dmmSubdimensionsResults(companyId, campaignId, type, graphName) {
    return await axioAdmin?.get(
        `${API_URL?.ChartData?.dmmSubdimensionsResultsId}?companyId=${companyId}&campaignId=${campaignId}&type=${type}&graphName=${graphName}`)
}
export async function overallParticipationDivision(companyId, campaignId, type, graphName) {
    return await axioAdmin?.get(
        `${API_URL?.ChartData?.overallParticipationDivisionId}?companyId=${companyId}&campaignId=${campaignId}&type=${type}&graphName=${graphName}`)
}
export async function overallParticipationJobLevel(companyId, campaignId, type, graphName) {
    return await axioAdmin?.get(
        `${API_URL?.ChartData?.overallParticipationJobLevelId}?companyId=${companyId}&campaignId=${campaignId}&type=${type}&graphName=${graphName}`)
}
export async function dimensionCurrent(companyId, campaignId, type, graphName) {
    return await axioAdmin?.get(
        `${API_URL?.ChartData?.dimensionCurrentId}?companyId=${companyId}&campaignId=${campaignId}&type=${type}&graphName=${graphName}`)
}
export async function dimensionFuture(companyId, campaignId, type, graphName) {
    return await axioAdmin?.get(
        `${API_URL?.ChartData?.dimensionFutureId}?companyId=${companyId}&campaignId=${campaignId}&type=${type}&graphName=${graphName}`)
}
export async function overallHeatMap(companyId, campaignId, type, graphName) {
    return await axioAdmin?.get(
        `${API_URL?.ChartData?.overAllHeatMap}?companyId=${companyId}&campaignId=${campaignId}&type=${type}&graphName=${graphName}`)
}
export async function divisionLevelHeatMap(companyId,campaignId, departmentOrHierachytype, type, graphName) {
    return await axioAdmin?.get(
        `${API_URL?.ChartData?.divisionLevelHeatmap}?companyId=${companyId}&campaignId=${campaignId}&departmentOrHierachytype=${departmentOrHierachytype}&type=${type}&graphName=${graphName}`)
}
export async function customerMaturityLine(companyId, campaignId, type, graphName) {
    return await axioAdmin?.get(
        `${API_URL?.ChartData?.customerMaturityLine}?companyId=${companyId}&campaignId=${campaignId}&type=${type}&graphName=${graphName}`)
}
export async function dimessionDeepDive(companyId, campaignId, type, graphName) {
    return await axioAdmin?.get(
        `${API_URL?.ChartData?.dimessionDeepDives}?companyId=${companyId}&campaignId=${campaignId}&type=${type}&graphName=${graphName}`)
}
export async function dimensionMaturityLineOverallVersusBenchmarkRecords(companyId, campaignId, type, graphName) {
    return await axioAdmin?.get(
        `${API_URL?.ChartData?.dimensionMaturityLineOverallVersusBenchmarkRecordsId}?companyId=${companyId}&campaignId=${campaignId}&type=${type}&graphName=${graphName}`)
}
export async function subDimensionMaturityLineOverallVersusBenchmark(companyId, campaignId, type, graphName) {
    return await axioAdmin?.get(
        `${API_URL?.ChartData?.subDimensionMaturityLineOverallVersusBenchmarkId}?companyId=${companyId}&campaignId=${campaignId}&type=${type}&graphName=${graphName}`)
}
export async function getAllDashboardDetails() {
    return await axioAdmin?.get(
        `${API_URL?.ChartData?.getDashboardDetails}`)
}
export async function getDashboardDetailsGraph() {
    return await axioAdmin?.get(
        `${API_URL?.ChartData?.getDashboardDetailsGraph}`)
}
/////end chart api ///////
export async function getCriteriaByModelId(Id, employeeId, campaignId) {
    return await axioUser?.get(
        `${API_URL?.CriteriaManagement?.getCriteriaByModelId}?id=${Id}&employeeId=${employeeId}&campaignId=${campaignId}`)
}

export async function addAssestmentByUser(payload) {
    return await axioUser?.post(
        `${API_URL?.userAssesment?.addAssesment}`, payload)
}
export async function getOptionsByCriteriaId(Id, employeeId, campaignId) {
    return await axioUser?.post(
        `${API_URL?.userAssesment?.userAssesmentOption}?criteriaId=${Id}&employeeId=${employeeId}&campaignId=${campaignId}`)
}
export async function getAllAnswerByEmpId(employeeId, campaignId) {
    return await axioUser?.post(
        `${API_URL?.userAssesment?.allAnswer}?employeeId=${employeeId}&campaignId=${campaignId}`)
}
export async function adminLogout(token) {
    return await axioAdmin?.get(
        `${API_URL?.adminAuth?.logout}?token=${token}`)
}
export async function userLogout(token) {
    return await axioUser?.get(
        `${API_URL?.userLogin?.logOut}?token=${token}`)
}
export async function changePasswordAdmin(payload) {
    return await axioAdmin?.post(
        `${API_URL?.adminAuth?.changePassword}`, payload)
}
export async function uploadFile(file) {
    return await axioAdmin?.post(
        `${API_URL?.adminAuth?.fileUpload}`, file)
}

export async function getAdminById(id) {
    return await axioAdmin?.get(
        `${API_URL?.adminAuth?.adminById}?id=${id}`)
}
export async function getUserById(id) {
    return await axioUser?.get(
        `${API_URL?.userLogin?.userDetails}?id=${id}`)
}
////////////////////////////////////Bulk Upload////////////////////////////
export async function BulkUploadCriteria(modelId, dimensionId, subDimensionId) {
    return await axioAdmin?.post(
        `${API_URL?.CriteriaManagement?.BulkUpload}?modelId=${modelId}&dimensionId=${dimensionId}&subDimensionId=${subDimensionId}`)
}

export async function EmployeeBulkUploads(companyId, formData) {
    return await axioAdmin.post(
        `${API_URL?.CustomerManagement.employeeBulkUpload}?companyId=${companyId}`,
        formData
    );
}

export async function addEmployeeAssigneAssisment(payload) {
    return await axioAdmin?.post(
        `${API_URL?.AssigmentAssesment?.addAssisment}`, payload)
}

export async function getAllAssignedEmployee(payload) {
    return await axioAdmin?.post(`${API_URL?.AssigmentAssesment?.getAssismentEmployee}`, payload);
}

export async function getAllAssignedEmployeeByCompanyId(payload) {
    return await axioAdmin?.post(`${API_URL?.AssigmentAssesment?.getAssismentEmployeeByCompanyId}`, payload);
}
export async function getAllAssignEmployeesByCampaignId(payload) {
    return await axioAdmin?.post(`${API_URL?.AssigmentAssesment?.getAllAssignEmployeesByCampaignId}`, payload);
}
export async function allNotification() {
    return await axioAdmin?.get(
        `${API_URL?.notification?.getAllNotification}`)
}
export async function statusChangeNotifiaction(Id, status) {
    return await axioAdmin?.get(
        `${API_URL?.notification?.changeNotificationStatus}?userAssessmentId=${Id}&seenStatus=${status}`)
}
export async function allOnsiteEmployee(payload) {
    return await axioAdmin?.post(
        `${API_URL?.CustomerManagement?.getAllOnsiteEmp}`, payload)
}

export async function getCriteriaByModelIdwithadmintoken(Id, employeeId, campaignId) {
    return await axioAdmin?.get(
        `${API_URL?.CriteriaManagement?.getCriteriaByModelId}?id=${Id}&employeeId=${employeeId}&campaignId=${campaignId}`)
}

export async function getAllAnswerByEmpIdwithAdminToken(employeeId, campaignId) {
    return await axioAdmin?.post(
        `${API_URL?.userAssesment?.allAnswer}?employeeId=${employeeId}&campaignId=${campaignId}`)
}

export async function getOptionsByCriteriaIdwithAdminToken(Id, employeeId, campaignId) {
    return await axioAdmin?.post(
        `${API_URL?.userAssesment?.userAssesmentOption}?criteriaId=${Id}&employeeId=${employeeId}&campaignId=${campaignId}`)
}
export async function addAssestmentByUserWithAdminToken(payload) {
    return await axioAdmin?.post(
        `${API_URL?.userAssesment?.addAssesment}`, payload)
}
export async function clearResponeAssesment(id) {
    return await axioUser?.get(
        `${API_URL?.userAssesment?.clearResponce}?id=${id}`)
}

export async function clearResponeAssesmentAdmin(id) {
    return await axioAdmin?.get(
        `${API_URL?.userAssesment?.clearResponce}?id=${id}`)
}
export async function getOrganizationWiseResult(id) {
    return await axioAdmin?.get(
        `${API_URL?.orgnigationwiseResult?.companywiesuserResult}?companyId=${id}`)
}

export async function getAllHirarchy(companyId) {
    return await axioAdmin?.get(
        `${API_URL?.CustomerManagement?.hirarchy}?companyId=${companyId}`)
}
export async function getAllDepartment(companyId) {
    return await axioAdmin?.get(
        `${API_URL?.CustomerManagement?.department}?companyId=${companyId}`)
}
export async function deleteModalById(Id) {
    return await axioAdmin?.post(
        `${API_URL?.ModelManagement?.deleteModal}?id=${Id}&isSoftDelete=true`)
}

export async function deleteCampaignById(Id) {
    return await axioAdmin?.delete(
        `${API_URL?.CustomerManagement?.deleteCampaign}?id=${Id}&status=true`)
}
export async function deleteDimensionById(Id) {
    return await axioAdmin?.post(
        `${API_URL?.DimensionManagement?.deleteDimension}?id=${Id}&isSoftDelete=true`)
}
export async function deleteSubDimensionById(Id) {
    return await axioAdmin?.post(
        `${API_URL?.SubDimensionManagement?.deleteSubDimension}?id=${Id}&isSoftDelete=true`)
}
export async function deleteCriteriaById(Id) {
    return await axioAdmin?.delete(
        `${API_URL?.CriteriaManagement?.deleteCriteria}?id=${Id}&status=true`)
}

export async function getCriteriaByModelIdwithfilter(Id, employeeId, campaignId, criteriaId) {
    // build the URL string dynamically
    let url = `${API_URL?.userAssesment?.userAssesmentByCriteraIdNew}?modelId=${Id}&employeeId=${employeeId}`;
    if (campaignId) {
        url += `&campaignId=${campaignId}`;
    }
    if (criteriaId) {
        url += `&criteriaId=${criteriaId}`;
    }
    // make the GET request
    return await axioUser.get(url);
}

export async function getCriteriaByModelIdwithfilterwithAdminToken(Id, employeeId, campaignId, criteriaId) {
    // build the URL string dynamically
    let url = `${API_URL?.userAssesment?.userAssesmentByCriteraIdNew}?modelId=${Id}&employeeId=${employeeId}`;
    if (campaignId) {
        url += `&campaignId=${campaignId}`;
    }
    if (criteriaId) {
        url += `&criteriaId=${criteriaId}`;
    }
    // make the GET request
    return await axioAdmin.get(url);
}

export async function getAllCampaignByEmployeeId(empId) {
    return await axioUser?.get(
        `${API_URL?.userAssesment?.campaignByEmployeeId}?employeeId=${empId}`)
}
export async function resendAssessmentLink(payload) {
    return await axioAdmin?.post(`${API_URL?.AssigmentAssesment?.resendAssessmentLink}`, payload);
}

export async function getAssessorsEmployeeList(payload) {
    return await axioAdmin?.post(`${API_URL?.Assessors?.getAllCompanyAssessors}`, payload);
}
export async function getAssessorsList(payload) {
    return await axioAdmin?.post(`${API_URL?.Assessors?.getAssessors}`, payload);
}

export async function deleteCompanyAssessorById(Id) {
    return await axioAdmin?.delete(
        `${API_URL?.Assessors?.deleteCompanyAssessorById}?id=${Id}&status=true`)
}

export async function addUpdateCompanyAssessorForm(payload) {
    return await axioAdmin?.post(`${API_URL?.Assessors?.addUpdateCompanyAssessor}`, payload);
}

export async function AssessoractiveInactive(id, status) {
    return await axioAdmin?.post(
        `${API_URL?.Assessors?.companyAssessorDeactivate}?id=${id}&status=${status}`)
}
export async function getEmployeeResult(campaignId, employeeId, modelId) {
    return await axioUser?.get(
        `${API_URL?.AssigmentAssesment?.EmployeeResult}?campaignId=${campaignId}&employeeId=${employeeId}&modelId=${modelId}`)
}
export async function getAllDimenstionbycampaign(campaignId) {
    return await axioAdmin?.get(
        `${API_URL?.ChartData?.getDimensionsByCampaignId}?campaignId=${campaignId}`)
}

export async function getEmployeeResultwithAdminToken(campaignId, employeeId, modelId) {
    return await axioAdmin?.get(
        `${API_URL?.AssigmentAssesment?.EmployeeResult}?campaignId=${campaignId}&employeeId=${employeeId}&modelId=${modelId}`)
}
